import React, { useState } from 'react'
import "./FloatingCartComponent.css"
import CartPopup from '../LMS Portal/CartPopup/CartPopup';
import { useSelector } from 'react-redux';
import Modal from '../Model/Modal';

function FloatingCartComponent({
  setOpenCart
}) {

      const [showCart, setShowCart] = useState(false)
      const closeModalCart = () => setShowCart(false);
  const userLoginStatus = JSON.parse(localStorage.getItem("userInfo"));
    const cartItems = useSelector((state)=> state.cartItems)
  return (
    <div className='FloatingCartComponent-container d-flex'>
                            <>
                            <div className="d-flex align-items-center justify-content-center h-100 w-100">
                                <div className="d-flex align-items-start ps-3 pt-2 " style={{cursor:"pointer"}} onClick={() => { if(window.innerWidth>996){setOpenCart(true)}else{setShowCart(true)} }}>
                                <img alt='cart icon' className='menu-icon' src='/images/icons/cart-icon.svg'  />
                                <div className="cart-white-icon">{cartItems.length}</div>
                                </div>
                                </div>
                                </>
                                {showCart &&
                                                  <Modal status={showCart}  closeModal={closeModalCart}>
                                                      <CartPopup closeModal={closeModalCart} />
                                                  </Modal>
                                              }
    </div>
  )
}

export default FloatingCartComponent